import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Postman extends PureComponent {
  render() {
    return (
      <div className="row" id="postman">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Using Postman</h2>
              <p>
                During the development process, we found Postman the easiest way
                to work with the Nexoid API. You can{" "}
                <PageLink
                  to="https://www.getpostman.com/"
                  text="download Postman here"
                />
                .
              </p>
              <p>
                Postman supports environment variables. Environment variables
                are a great way of managing variables like your Session ID,
                which will change every time you call the Sign-In function.
              </p>
              <p>
                To use the postman environment variables example, you will need
                to download and install Postman and get your API URL and
                Customer ID using the Get API URL function.
              </p>
              <p>
                More information on the Sign-In process can be found in the
                Authentication Sign-In part of this document.
              </p>
              <div>Reference material:</div>
              <div className="divP i1">
                <PageLink to="https://www.getpostman.com/" text="Postman" />{" "}
                <br />
                <PageLink to="/api#url" text="Get API URL" /> <br />
                <PageLink to="/api#sign_in" text="Sign In" /> <br />
              </div>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Postman Environment Variables</h2>
            </section>
            <section>
              <h3>Simple Authentication Request</h3>
              <p>
                This example authenticates the user "greg" with the password
                "password123" against Customer ID "592" on API cluster
                "example.api.nexoid.com".
              </p>
              <p>URL:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/sign_in/
                <strong>
                  <span className="jsonY">greg</span>
                </strong>
              </div>
              <p>Request Body:</p>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"customer_id"</span>:{" "}
                  <span className="jsonY">"592"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"password"</span>:{" "}
                  <span className="jsonY">"password123"</span>
                </div>
                <div>&#125;</div>
              </div>
              <h3>Postman Saving Session ID</h3>
              <p>
                By copying this code into the test section of Postman, the
                Session ID returned by a successful authentication will be saved
                as a managed variable.
              </p>
              <p>Postman Tests:</p>
              <div className="darkCode">
                <div>
                  <span className="jsonPink">if</span> (responseCode.code{" "}
                  <span className="jsonPink">===</span>{" "}
                  <span className="jsonP">200</span>) &#123;
                </div>
                <div className="i1">
                  <span className="jsonA">var</span> data{" "}
                  <span className="jsonPink">=</span>{" "}
                  <span className="jsonG">JSON</span>.
                  <span className="jsonA">parse</span>(responseBody);
                </div>
                <div className="i1">
                  postman.setEnvironmentVariable(
                  <span className="jsonY">"session_id"</span>, data.session_id);
                </div>
                <div>&#125;</div>
              </div>
              <h3>Using a Saved Session ID</h3>
              <p>
                Once your Session ID is saved as a managed variable in Postman
                you can then create requests by using the{" "}
                <strong>&#123;&#123;session_id&#125;&#125;</strong> placeholder
                and Postman will replace it as you send the request.
              </p>
              <p>URL:</p>
              <div className="darkCode">
                <span className="methodCodeGET">GET</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/record/incdient/
                <span className="jsonY">5764</span>?session_id=
                <span className="jsonO">
                  <strong>&#123;&#123;session_id&#125;&#125;</strong>
                </span>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Postman;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Postman.js